import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import { LabeledChipAppearance } from '@components/v2/ui/LabeledChip/labeledChip.styles';
import { CSSProperties, ReactElement, ReactNode } from 'react';

interface DynamicTagWithTooltipProps {
  label: string;
  variant?: LabeledChipAppearance;
  style?: CSSProperties;
  tooltipTitle?: ReactNode;
  icon?: ReactElement;
}

const DynamicTagWithTooltip = ({
  label,
  variant,
  style,
  tooltipTitle,
  icon,
}: DynamicTagWithTooltipProps) => (
  <LabeledChip
    content={label}
    appearance={variant}
    sx={style}
    title={label}
    tooltip={tooltipTitle || undefined}
    icon={icon}
  />
);

export default DynamicTagWithTooltip;
